module.exports = __webpack_public_path__ + "static/media/azerbeidzan-large.497fefd6.jpg";